import React from "react"
import PropTypes from "prop-types"
import { DataGridPro } from "@mui/x-data-grid-pro"
import Switch from "@mui/material/Switch"
import { useEditTax } from "./hooks/useTaxes"
import i18n from "i18n"

const TaxesGrid = ({ taxes, onTaxesChange, organizationId }) => {
  const editTax = useEditTax(organizationId)
  const handleProcessRowUpdate = newRow => {
    const updatedRows = taxes.map(row =>
      row.SK === newRow.SK ? { ...row, ...newRow } : row,
    )
    if (onTaxesChange) onTaxesChange(updatedRows)
    editTax.mutate(newRow)
    return newRow
  }

  return (
    <div style={{ width: "100%", height: 318 }}>
      <DataGridPro
        rows={taxes}
        getRowId={row => row.SK}
        slots={{
          noRowsOverlay: () => null,
        }}
        columns={[
          {
            field: "longName",
            headerName: i18n.t("taxes.name"),
            width: 330,
            editable: false,
          },
          {
            field: "value",
            headerName: i18n.t("taxes.percentage"),
            width: 100,
            align: "center",
            headerAlign: "center",
            editable: false,
            type: "number",
          },
          {
            field: "active",
            headerName: i18n.t("taxes.active"),
            width: 100,
            align: "center",
            headerAlign: "right",
            renderCell: params => {
              return (
                <Switch
                  checked={!!params.value}
                  color="primary"
                  inputProps={{ "aria-label": "toggle activo" }}
                  onChange={e => {
                    const updated = taxes.map(row =>
                      row.SK === params.id
                        ? { ...row, active: e.target.checked }
                        : row,
                    )
                    if (onTaxesChange) onTaxesChange(updated)
                    // Backend update if not temp
                    const changedTax = updated.find(row => row.SK === params.id)
                    if (changedTax && !changedTax.SK.startsWith("temp-")) {
                      editTax.mutate(changedTax)
                    }
                  }}
                  sx={{
                    position: "relative",
                    top: 2,
                    left: 20,
                    "& .MuiSwitch-thumb": {
                      width: 12,
                      height: 12,
                    },
                    "& .MuiSwitch-track": {
                      borderRadius: 20,
                      minWidth: 40,
                      height: 20,
                      position: "relative",
                      top: -6,
                      left: -6,
                    },
                  }}
                />
              )
            },
          },
        ]}
        processRowUpdate={handleProcessRowUpdate}
        experimentalFeatures={{ newEditingApi: true }}
        disableSelectionOnClick
        checkboxSelection={false}
        disableColumnMenu
        hideFooterSelectedRowCount
        isRowSelectable={() => false}
        hideFooter
      />
    </div>
  )
}

TaxesGrid.propTypes = {
  taxes: PropTypes.array,
  onTaxesChange: PropTypes.func,
  organizationId: PropTypes.string.isRequired,
}
TaxesGrid.defaultProps = {
  taxes: [],
}

export default TaxesGrid
